import { useLocation } from 'react-router-dom';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { TaskType } from '../../../../../store/api/tasks-api';
import { useTaskStore } from '../../../../../store/use-task-store';
import s from './tasks-marks.module.css';
import { TasksWidget } from './tasks-widget/tasks-widget';

export const TaskMarks = () => {
  const { process, done, fake } = useTaskStore();
  const { t, getLocale } = useLang();
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const isWidgetExpanded = params.is_expanded === '1';
  const isOrder = useLocation().pathname.split('/')[3] === 'order';
  const getRows = (tasks?: TaskType[]) => tasks?.map((item) => ({ text: getLocale(item.title) }));

  return (
    <div className={s.feature}>
      <TasksWidget
        type="new"
        label={t('Новые задачи')}
        className={s.new}
        isExpanded={isWidgetExpanded}
        count={process?.length}
        rows={getRows(process)}
      />
      <TasksWidget
        type="done"
        label={t('Выполненные задачи')}
        className={s.done}
        isExpanded={isWidgetExpanded}
        count={done?.length}
        rows={getRows(done)}
      />
      <TasksWidget
        type="fake"
        label={t( isOrder ? 'Отклоненные задачи' : 'Ложные задачи')}
        className={s.fake}
        isExpanded={isWidgetExpanded}
        count={fake?.length}
        rows={getRows(fake)}
      />
    </div>
  );
};
